import React from "react";

import "./OverlayLoader.scss";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

function OverlayLoader() {
  return (
    <div className="overlay-loading-container">
      <LoadingSpinner />
    </div>
  );
}

export default OverlayLoader;
